var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarIconsMitre(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mitre__State=Mitre, Type=Enabled",
    className: "mitre__State=Mitre, mitre__Type=Enabled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mitre__Vector",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.5 20.401c0 .58.47 1.05 1.05 1.05H5.7a1.05 1.05 0 1 0 0-2.1H2.55c-.58 0-1.05.47-1.05 1.05Zm0-4.2c0 .58.47 1.05 1.05 1.05H5.7a1.05 1.05 0 1 0 0-2.1H2.55c-.58 0-1.05.47-1.05 1.05Zm15.75 0c0 .58.47 1.05 1.05 1.05h3.15a1.05 1.05 0 1 0 0-2.1H18.3c-.58 0-1.05.47-1.05 1.05Zm-15.75-4.2c0 .58.47 1.05 1.05 1.05H5.7a1.05 1.05 0 1 0 0-2.1H2.55c-.58 0-1.05.47-1.05 1.05Zm7.875 0c0 .58.47 1.05 1.05 1.05h3.15a1.05 1.05 0 1 0 0-2.1h-3.15c-.58 0-1.05.47-1.05 1.05Zm7.875 0c0 .58.47 1.05 1.05 1.05h3.15a1.05 1.05 0 1 0 0-2.1H18.3c-.58 0-1.05.47-1.05 1.05ZM1.5 7.801c0 .58.47 1.05 1.05 1.05H5.7a1.05 1.05 0 1 0 0-2.1H2.55c-.58 0-1.05.47-1.05 1.05Zm7.875 0c0 .58.47 1.05 1.05 1.05h3.15a1.05 1.05 0 1 0 0-2.1h-3.15c-.58 0-1.05.47-1.05 1.05Zm7.875 0c0 .58.47 1.05 1.05 1.05h3.15a1.05 1.05 0 1 0 0-2.1H18.3c-.58 0-1.05.47-1.05 1.05ZM1.5 3.601c0 .58.47 1.05 1.05 1.05H5.7a1.05 1.05 0 1 0 0-2.1H2.55c-.58 0-1.05.47-1.05 1.05Zm7.875 0c0 .58.47 1.05 1.05 1.05h3.15a1.05 1.05 0 1 0 0-2.1h-3.15c-.58 0-1.05.47-1.05 1.05Zm7.875 0c0 .58.47 1.05 1.05 1.05h3.15a1.05 1.05 0 1 0 0-2.1H18.3c-.58 0-1.05.47-1.05 1.05Z",
    className: "mitre__Vector",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIconsMitre);
export default __webpack_public_path__ + "static/media/sidebar-icons-mitre.05e52e22e895b0944b334f468bda3697.svg";
export { ForwardRef as ReactComponent };